<template>
  <DownloadList :config="config" />
</template>

<script>
import DownloadList from "../../components/DownloadList/DownloadList.vue";

export default {
  name: "app",
  components: {
    DownloadList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
